
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import AttendanceCompoment from "../components/attendance/Attendance-compoment"
import AttendanceCount from "./Attendance-count"
export default {
name: "Attendance",
directives: {
TransferDom
},
components: {
XHeader, Group, Cell, CellBox, Flexbox, FlexboxItem, Radio, PopupHeader, Popup, XTextarea, XButton, Tabbar, TabbarItem,AttendanceCompoment ,AttendanceCount
},
data () {
return {
pageTitle: '',
userName: false,
tabbarIndex: 0
}
},
mounted () {
if(this.$store.state.userInfo.accounts){
this.userName = this.$store.state.userInfo.accounts;
};
},
methods: {
goLogin () {
this.$router.push({ name: 'Login'});
}
}
}



// WEBPACK FOOTER //
// ./src/page/Attendance.vue